import { createI18n } from 'vue-i18n'
import cache from '@/utils/cache'

// element-plus 国际化文件
import element_zh_cn from 'element-plus/es/locale/lang/zh-cn'
import element_en from 'element-plus/es/locale/lang/en'
import element_es from 'element-plus/es/locale/lang/es'

// 框架 国际化文件
import zhCnLocale from './lang/zh-CN'
import enUsLocale from './lang/en-US'
import esEsLocale from './lang/es-ES'

// 设备列表国际化文件
import deviceList_zh_cn from './lang/device_list/zh-CN'
import deviceList_en from './lang/device_list/en-US'
import deviceList_es from './lang/device_list/es-ES'

// 组件国际化文件
import components_zh_cn from './lang/components/zh-CN'
import components_en from './lang/components/en-US'
import components_es from './lang/components/es-ES'

// expdig diagnose 国际化文件
import expdigDiagnose_zh_cn from './lang/expdig_diagnose/zh-CN'
import expdigDiagnose_en from './lang/expdig_diagnose/en-US'
import expdigDiagnose_es from './lang/expdig_diagnose/es-ES'

// biz_inspect_cal_warn 国际化文件
import bizInspectCalWarn_zh_cn from './lang/biz_inspect_cal_warn/zh-CN'
import bizInspectCalWarn_en from './lang/biz_inspect_cal_warn/en-US'
import bizInspectCalWarn_es from './lang/biz_inspect_cal_warn/es-ES'

// biz_inspect_statistics_report 国际化文件
import bizInspectStatisticsReport_zh_cn from './lang/biz_inspect_statistics_report/zh-CN'
import bizInspectStatisticsReport_en from './lang/biz_inspect_statistics_report/en-US'
import bizInspectStatisticsReport_es from './lang/biz_inspect_statistics_report/es-ES'

//biz_order 国际化文件
import bizOrder_zh_cn from './lang/biz_order/zh-CN'
import bizOrder_en from './lang/biz_order/en-US'
import bizOrder_es from './lang/biz_order/es-ES'

// biz_inspect_device_report 国际化文件
import bizInspectDeviceReport_zh_cn from './lang/biz_inspect_device_report/zh-CN'
import bizInspectDeviceReport_en from './lang/biz_inspect_device_report/en-US'
import bizInspectDeviceReport_es from './lang/biz_inspect_device_report/es-ES'

// biz_inspect_report 国际化文件
import bizInspectReport_zh_cn from './lang/biz_inspect_report/zh-CN'
import bizInspectReport_en from './lang/biz_inspect_report/en-US'
import bizInspectReport_es from './lang/biz_inspect_report/es-ES'

// biz_inspect_month_report 国际化文件
import bizInspectMonthReport_zh_cn from './lang/biz_inspect_month_report/zh-CN'
import bizInspectMonthReport_en from './lang/biz_inspect_month_report/en-US'
import bizInspectMonthReport_es from './lang/biz_inspect_month_report/es-ES'

// biz_inspect_case 国际化文件
import bizInspectCase_zh_cn from './lang/biz_inspect_case/zh-CN'
import bizInspectCase_en from './lang/biz_inspect_case/en-US'
import bizInspectCase_es from './lang/biz_inspect_case/es-ES'

// biz_inspect_bearing 国际化文件
import bizInspectBearing_zh_cn from './lang/biz_inspect_bearing/zh-CN'
import bizInspectBearing_en from './lang/biz_inspect_bearing/en-US'
import bizInspectBearing_es from './lang/biz_inspect_bearing/es-ES'

// biz_device_gear_info 国际化文件
import bizDeviceGearInfo_zh_cn from './lang/biz_device_gear_info/zh-CN'
import bizDeviceGearInfo_en from './lang/biz_device_gear_info/en-US'
import bizDeviceGearInfo_es from './lang/biz_device_gear_info/es-ES'

// biz_inspect_terminal_channel 国际化文件
import bizInspectTerminalChannel_zh_cn from './lang/biz_inspect_terminal_channel/zh-CN'
import bizInspectTerminalChannel_en from './lang/biz_inspect_terminal_channel/en-US'
import bizInspectTerminalChannel_es from './lang/biz_inspect_terminal_channel/es-ES'

// biz_inspet_sensor 国际化文件
import bizInspectSensor_zh_cn from './lang/biz_inspect_sensor/zh-CN'
import bizInspectSensor_en from './lang/biz_inspect_sensor/en-US'
import bizInspectSensor_es from './lang/biz_inspect_sensor/es-ES'

// biz_inspect_terminal_diagnose 国际化文件
import bizInspectTerminalDiagnose_zh_cn from './lang/biz_inspect_terminal_diagnose/zh-CN'
import bizInspectTerminalDiagnose_en from './lang/biz_inspect_terminal_diagnose/en-US'
import bizInspectTerminalDiagnose_es from './lang/biz_inspect_terminal_diagnose/es-ES'

// biz_cal_mode 国际化文件
import bizCalMode_zh_cn from './lang/biz_cal_mode/zh-CN'
import bizCalMode_en from './lang/biz_cal_mode/en-US'
import bizCalMode_es from './lang/biz_cal_mode/es-ES'

// biz_algorithm_group 国际化文件
import bizAlgorithmGroup_zh_cn from './lang/biz_algorithm_group/zh-CN'
import bizAlgorithmGroup_en from './lang/biz_algorithm_group/en-US'
import bizAlgorithmGroup_es from './lang/biz_algorithm_group/es-ES'

//biz_algorithm_config 国际化文件
import bizAlgorithmConfig_zh_cn from './lang/biz_algorithm_config/zh-CN'
import bizAlgorithmConfig_en from './lang/biz_algorithm_config/en-US'
import bizAlgorithmConfig_es from './lang/biz_algorithm_config/es-ES'

// biz_device_health_controller 国际化文件
import bizDeviceHealthController_zh_cn from './lang/biz_device_health_controller/zh-CN'
import bizDeviceHealthController_en from './lang/biz_device_health_controller/en-US'
import bizDeviceHealthController_es from './lang/biz_device_health_controller/es-ES'

// biz_inspect_terminal 国际化文件
import bizInspectTerminal_zh_cn from './lang/biz_inspect_terminal/zh-CN'
import bizInspectTerminal_en from './lang/biz_inspect_terminal/en-US'
import bizInspectTerminal_es from './lang/biz_inspect_terminal/es-ES'

// biz_collector_define 国际化文件
import bizCollectorDefine_zh_cn from './lang/biz_collector_define/zh-CN'
import bizCollectorDefine_en from './lang/biz_collector_define/en-US'
import bizCollectorDefine_es from './lang/biz_collector_define/es-ES'

// biz_inspect_eigen_def 国际化文件
import bizInspectEigenDef_zh_cn from './lang/biz_inspect_eigen_def/zh-CN'
import bizInspectEigenDef_en from './lang/biz_inspect_eigen_def/en-US'
import bizInspectEigenDef_es from './lang/biz_inspect_eigen_def/es-ES'

// biz_collector_config 国际化文件
import bizCollectorConfig_zh_cn from './lang/biz_collector_config/zh-CN'
import bizCollectorConfig_en from './lang/biz_collector_config/en-US'
import bizCollectorConfig_es from './lang/biz_collector_config/es-ES'

// biz_inspect_wave_def 国际化文件
import bizInspectWaveDef_zh_cn from './lang/biz_inspect_wave_def/zh-CN'
import bizInspectWaveDef_en from './lang/biz_inspect_wave_def/en-US'
import bizInspectWaveDef_es from './lang/biz_inspect_wave_def/es-ES'

// biz_inspect_iot_card 国际化文件
import bizInspectIotCard_zh_cn from './lang/biz_inspect_iot_card/zh-CN'
import bizInspectIotCard_en from './lang/biz_inspect_iot_card/en-US'
import bizInspectIotCard_es from './lang/biz_inspect_iot_card/es-ES'

// biz_inspect_terminal_type 国际化文件
import bizInspectTerminalType_zh_cn from './lang/biz_inspect_terminal_type/zh-CN'
import bizInspectTerminalType_en from './lang/biz_inspect_terminal_type/en-US'
import bizInspectTerminalType_es from './lang/biz_inspect_terminal_type/es-ES'

// biz_inspect_sensor_type 国际化文件
import bizInspectSensorType_zh_cn from './lang/biz_inspect_sensor_type/zh-CN'
import bizInspectSensorType_en from './lang/biz_inspect_sensor_type/en-US'
import bizInspectSensorType_es from './lang/biz_inspect_sensor_type/es-ES'

// biz_device_image 国际化文件
import bizDeviceImage_zh_cn from './lang/biz_device_image/zh-CN'
import bizDeviceImage_en from './lang/biz_device_image/en-US'
import bizDeviceImage_es from './lang/biz_device_image/es-ES'

// biz_analysis_toolkit 国际化文件
import bizAnalysisToolkit_zh_cn from './lang/biz_analysis_toolkit/zh-CN'
import bizAnalysisToolkit_en from './lang/biz_analysis_toolkit/en-US'
import bizAnalysisToolkit_es from './lang/biz_analysis_toolkit/es-ES'

// biz_inspect_device_analytical_tool 国际化文件
import bizInspectDeviceAnalyticalTool_zh_cn from './lang/biz_inspect_device_analytical_tool/zh-CN'
import bizInspectDeviceAnalyticalTool_en from './lang/biz_inspect_device_analytical_tool/en-US'
import bizInspectDeviceAnalyticalTool_es from './lang/biz_inspect_device_analytical_tool/es-ES'

// biz_inspect_org 国际化文件
import bizInspectOrg_zh_cn from './lang/biz_inspect_org/zh-CN'
import bizInspectOrg_en from './lang/biz_inspect_org/en-US'
import bizInspectOrg_es from './lang/biz_inspect_org/es-ES'

// biz_inspect_device_mange 国际化文件
import bizInspectDeviceMange_zh_cn from './lang/biz_inspect_device_mange/zh-CN'
import bizInspectDeviceMange_en from './lang/biz_inspect_device_mange/en-US'
import bizInspectDeviceMange_es from './lang/biz_inspect_device_mange/es-ES'

// biz_inspect_device 国际化文件
import bizInspectDevice_zh_cn from './lang/biz_inspect_device/zh-CN'
import bizInspectDevice_en from './lang/biz_inspect_device/en-US'
import bizInspectDevice_es from './lang/biz_inspect_device/es-ES'

// device_annotation 国际化文件
import deviceAnnotation_zh_cn from './lang/device_annotation/zh-CN'
import deviceAnnotation_en from './lang/device_annotation/en-US'
import deviceAnnotation_es from './lang/device_annotation/es-ES'

// biz_inspect_device_type 国际化文件
import bizInspectDeviceType_zh_cn from './lang/biz_inspect_device_type/zh-CN'
import bizInspectDeviceType_en from './lang/biz_inspect_device_type/en-US'
import bizInspectDeviceType_es from './lang/biz_inspect_device_type/es-ES'

// biz_inspect_month_report_config 国际化文件
import bizInspectMonthReportConfig_zh_cn from './lang/biz_inspect_month_report_config/zh-CN'
import bizInspectMonthReportConfig_en from './lang/biz_inspect_month_report_config/en-US'
import bizInspectMonthReportConfig_es from './lang/biz_inspect_month_report_config/es-ES'

// biz_inspect_cylinder 国际化文件
import bizInspectCylinder_zh_cn from './lang/biz_inspect_cylinder/zh-CN'
import bizInspectCylinder_en from './lang/biz_inspect_cylinder/en-US'
import bizInspectCylinder_es from './lang/biz_inspect_cylinder/es-ES'

// biz_warn_notice 国际化文件
import bizWarnNotice_zh_cn from './lang/biz_warn_notice/zh-CN'
import bizWarnNotice_en from './lang/biz_warn_notice/en-US'
import bizWarnNotice_es from './lang/biz_warn_notice/es-ES'

// biz_warn_handle 国际化文件
import bizWarnHandle_zh_cn from './lang/biz_warn_handle/zh-CN'
import bizWarnHandle_en from './lang/biz_warn_handle/en-US'
import bizWarnHandle_es from './lang/biz_warn_handle/es-ES'

// biz_inspect_sensor_diagnose 国际化文件
import bizInspectSensorDiagnose_zh_cn from './lang/biz_inspect_sensor_diagnose/zh-CN'
import bizInspectSensorDiagnose_en from './lang/biz_inspect_sensor_diagnose/en-US'
import bizInspectSensorDiagnose_es from './lang/biz_inspect_sensor_diagnose/es-ES'

import profile_zh_cn from './lang/profile/zh-CN'
import profile_en from './lang/profile/en-US'
import profile_es from './lang/profile/en-ES'

export const messages: { [key: string]: any } = {
	'zh-CN': {
		langName: '简体中文',
		...zhCnLocale,
		el: {
			...element_zh_cn
		},
		deviceListModule: deviceList_zh_cn,
		componentsModule: components_zh_cn,
		expdigDiagnoseModule: expdigDiagnose_zh_cn,
		bizInspectCalWarnModule: bizInspectCalWarn_zh_cn,
		bizInspectStatisticsReportModule: bizInspectStatisticsReport_zh_cn,
		bizOrderModule: bizOrder_zh_cn,
		bizInspectDeviceReportModule: bizInspectDeviceReport_zh_cn,
		bizInspectReportModule: bizInspectReport_zh_cn,
		bizInspectCaseModule: bizInspectCase_zh_cn,
		bizInspectMonthReportModule: bizInspectMonthReport_zh_cn,
		bizInspectBearingModule: bizInspectBearing_zh_cn,
		bizDeviceGearInfoModule: bizDeviceGearInfo_zh_cn,
		bizInspectTerminalChannelModule: bizInspectTerminalChannel_zh_cn,
		bizInspectSensorModule: bizInspectSensor_zh_cn,
		bizInspectTerminalDiagnoseModule: bizInspectTerminalDiagnose_zh_cn,
		bizCalModeModule: bizCalMode_zh_cn,
		bizAlgorithmGroupModule: bizAlgorithmGroup_zh_cn,
		bizAlgorithmConfigModule: bizAlgorithmConfig_zh_cn,
		bizDeviceHealthControllerModule: bizDeviceHealthController_zh_cn,
		bizInspectTerminalModule: bizInspectTerminal_zh_cn,
		bizCollectorDefineModule: bizCollectorDefine_zh_cn,
		bizCollectorConfigModule: bizCollectorConfig_zh_cn,
		bizInspectEigenDefModule: bizInspectEigenDef_zh_cn,
		bizInspectWaveDefModule: bizInspectWaveDef_zh_cn,
		bizInspectIotCardModule: bizInspectIotCard_zh_cn,
		bizInspectTerminalTypeModule: bizInspectTerminalType_zh_cn,
		bizInspectSensorTypeModule: bizInspectSensorType_zh_cn,
		bizInspectOrgModule: bizInspectOrg_zh_cn,
		bizInspectDeviceMangeModule: bizInspectDeviceMange_zh_cn,
		bizInspectDeviceModule: bizInspectDevice_zh_cn,
		bizInspectDeviceTypeModule: bizInspectDeviceType_zh_cn,
		bizInspectMonthReportConfigModule: bizInspectMonthReportConfig_zh_cn,
		bizInspectCylinderModule: bizInspectCylinder_zh_cn,
		bizWarnNoticeModule: bizWarnNotice_zh_cn,
		bizWarnHandleModule: bizWarnHandle_zh_cn,
		bizInspectSensorDiagnoseModule: bizInspectSensorDiagnose_zh_cn,
		bizAnalysisToolkitModule: bizAnalysisToolkit_zh_cn,
		bizInspectDeviceAnalyticalToolModule: bizInspectDeviceAnalyticalTool_zh_cn,
		bizDeviceImageModule: bizDeviceImage_zh_cn,
		deviceAnnotationModule: deviceAnnotation_zh_cn,
		profileModule: profile_zh_cn
	},
	'en-US': {
		langName: 'English',
		...enUsLocale,
		el: {
			...element_en
		},
		deviceListModule: deviceList_en,
		componentsModule: components_en,
		expdigDiagnoseModule: expdigDiagnose_en,
		bizInspectCalWarnModule: bizInspectCalWarn_en,
		bizInspectStatisticsReportModule: bizInspectStatisticsReport_en,
		bizOrderModule: bizOrder_en,
		bizInspectDeviceReportModule: bizInspectDeviceReport_en,
		bizInspectReportModule: bizInspectReport_en,
		bizInspectCaseModule: bizInspectCase_en,
		bizInspectMonthReportModule: bizInspectMonthReport_en,
		bizInspectBearingModule: bizInspectBearing_en,
		bizDeviceGearInfoModule: bizDeviceGearInfo_en,
		bizInspectTerminalChannelModule: bizInspectTerminalChannel_en,
		bizInspectSensorModule: bizInspectSensor_en,
		bizInspectTerminalDiagnoseModule: bizInspectTerminalDiagnose_en,
		bizCalModeModule: bizCalMode_en,
		bizAlgorithmGroupModule: bizAlgorithmGroup_en,
		bizAlgorithmConfigModule: bizAlgorithmConfig_en,
		bizDeviceHealthControllerModule: bizDeviceHealthController_en,
		bizInspectTerminalModule: bizInspectTerminal_en,
		bizCollectorDefineModule: bizCollectorDefine_en,
		bizCollectorConfigModule: bizCollectorConfig_en,
		bizInspectEigenDefModule: bizInspectEigenDef_en,
		bizInspectWaveDefModule: bizInspectWaveDef_en,
		bizInspectIotCardModule: bizInspectIotCard_en,
		bizInspectTerminalTypeModule: bizInspectTerminalType_en,
		bizInspectSensorTypeModule: bizInspectSensorType_en,
		bizInspectOrgModule: bizInspectOrg_en,
		bizInspectDeviceMangeModule: bizInspectDeviceMange_en,
		bizInspectDeviceModule: bizInspectDevice_en,
		bizInspectDeviceTypeModule: bizInspectDeviceType_en,
		bizInspectMonthReportConfigModule: bizInspectMonthReportConfig_en,
		bizInspectCylinderModule: bizInspectCylinder_en,
		bizWarnNoticeModule: bizWarnNotice_en,
		bizWarnHandleModule: bizWarnHandle_en,
		bizInspectSensorDiagnoseModule: bizInspectSensorDiagnose_en,
		bizAnalysisToolkitModule: bizAnalysisToolkit_en,
		bizInspectDeviceAnalyticalToolModule: bizInspectDeviceAnalyticalTool_en,
		bizDeviceImageModule: bizDeviceImage_en,
		deviceAnnotationModule: deviceAnnotation_en,
		profileModule: profile_en
	},
	'es-ES': {
		langName: 'Español',
		...esEsLocale,
		el: {
			...element_es
		},
		deviceListModule: deviceList_es,
		componentsModule: components_es,
		expdigDiagnoseModule: expdigDiagnose_es,
		bizInspectCalWarnModule: bizInspectCalWarn_es,
		bizInspectStatisticsReportModule: bizInspectStatisticsReport_es,
		bizOrderModule: bizOrder_es,
		bizInspectDeviceReportModule: bizInspectDeviceReport_es,
		bizInspectReportModule: bizInspectReport_es,
		bizInspectCaseModule: bizInspectCase_es,
		bizInspectMonthReportModule: bizInspectMonthReport_es,
		bizInspectBearingModule: bizInspectBearing_es,
		bizDeviceGearInfoModule: bizDeviceGearInfo_es,
		bizInspectTerminalChannelModule: bizInspectTerminalChannel_es,
		bizInspectSensorModule: bizInspectSensor_es,
		bizInspectTerminalDiagnoseModule: bizInspectTerminalDiagnose_es,
		bizCalModeModule: bizCalMode_es,
		bizAlgorithmGroupModule: bizAlgorithmGroup_es,
		bizAlgorithmConfigModule: bizAlgorithmConfig_es,
		bizDeviceHealthControllerModule: bizDeviceHealthController_es,
		bizInspectTerminalModule: bizInspectTerminal_es,
		bizCollectorDefineModule: bizCollectorDefine_es,
		bizCollectorConfigModule: bizCollectorConfig_es,
		bizInspectEigenDefModule: bizInspectEigenDef_es,
		bizInspectWaveDefModule: bizInspectWaveDef_es,
		bizInspectIotCardModule: bizInspectIotCard_es,
		bizInspectTerminalTypeModule: bizInspectTerminalType_es,
		bizInspectSensorTypeModule: bizInspectSensorType_es,
		bizInspectOrgModule: bizInspectOrg_es,
		bizInspectDeviceMangeModule: bizInspectDeviceMange_es,
		bizInspectDeviceModule: bizInspectDevice_es,
		bizInspectDeviceTypeModule: bizInspectDeviceType_es,
		bizInspectMonthReportConfigModule: bizInspectMonthReportConfig_es,
		bizInspectCylinderModule: bizInspectCylinder_es,
		bizWarnNoticeModule: bizWarnNotice_es,
		bizWarnHandleModule: bizWarnHandle_es,
		bizInspectSensorDiagnoseModule: bizInspectSensorDiagnose_es,
		bizAnalysisToolkitModule: bizAnalysisToolkit_es,
		bizInspectDeviceAnalyticalToolModule: bizInspectDeviceAnalyticalTool_es,
		bizDeviceImageModule: bizDeviceImage_es,
		deviceAnnotationModule: deviceAnnotation_es,
		profileModule: profile_es
	}
}

// 返回当前 Language
function getLanguage() {
	return cache.getLanguage()
}

export const i18n = createI18n({
	allowComposition: true,
	globalInjection: true,
	legacy: false,
	locale: getLanguage(),
	messages
})
